export default __webpack_public_path__ + "f179cf7827d7fc39d908bc419f86ad21.png";